module.exports = __webpack_public_path__ + "static/media/misstnksam.f786c179.mp3";